import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { reusableFetch } from "../../utils/useAxios";

export const getAnnouncements = createAsyncThunk("announcement/getAnnouncements", async (data, { rejectWithValue }) => {
  const announcement = await reusableFetch(`announcement/all`, "POST", data, rejectWithValue);
  return announcement;
});

export const getAnnouncementById = createAsyncThunk("announcement/getAnnouncementById", async ({ announcementId }, { rejectWithValue }) => {
  const announcement = await reusableFetch(`announcement/${announcementId}`, "GET", {}, rejectWithValue);
  return announcement;
});

export const startAnnouncement = createAsyncThunk("announcement/startAnnouncement", async (data, { rejectWithValue }) => {
  const announcement = await reusableFetch(`announcement/`, "POST", data, rejectWithValue);
  return announcement;
});

export const updateAnnouncement = createAsyncThunk("announcement/updateAnnouncement", async (data, { rejectWithValue }) => {
  const announcement = await reusableFetch(`announcement/${data.announcementId}`, "PUT", data, rejectWithValue);
  return announcement;
});

export const updateAnnouncementStatus = createAsyncThunk("announcement/updateAnnouncementStatus", async ({ announcementId, status }, { rejectWithValue }) => {
  const announcement = await reusableFetch(`announcement/status/${announcementId}`, "PATCH", { status }, rejectWithValue);
  return announcement;
});

const initialState = {
  announcements: null, // List
  announcement: null,
  isAnnouncementStarting: false,
  isUpdatingAnnouncement: false,
  isGettingAnnouncements: false,
  isGettingAnnouncementData: false,
  isAnnouncementStatusUpdating: false,
};

export const announcementSlice = createSlice({
  name: "announcement",
  initialState,
  reducers: {
    saveAnnouncementValue: (state, action) => _.merge(state, action.payload),
    clearAnnouncementState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(startAnnouncement.pending, (state, { payload }) => {
        state.isAnnouncementStarting = true;
      })
      .addCase(startAnnouncement.fulfilled, (state, { payload }) => {
        state.isAnnouncementStarting = false;
        state.announcement = payload?.data?.data?.announcement;
      })
      .addCase(startAnnouncement.rejected, (state, { payload }) => {
        state.isAnnouncementStarting = false;
      })
      .addCase(getAnnouncements.pending, (state, { payload }) => {
        state.isGettingAnnouncements = true;
      })
      .addCase(getAnnouncements.fulfilled, (state, { payload }) => {
        state.isGettingAnnouncements = false;
        state.announcements = payload?.data?.data?.getAllAnnouncementData || null;
      })
      .addCase(getAnnouncements.rejected, (state, { payload }) => {
        state.isGettingAnnouncements = false;
      })
      .addCase(getAnnouncementById.pending, (state, { payload }) => {
        state.isGettingAnnouncementData = true;
      })
      .addCase(getAnnouncementById.fulfilled, (state, { payload }) => {
        state.isGettingAnnouncementData = false;
        state.announcement = payload?.data?.data;
      })
      .addCase(getAnnouncementById.rejected, (state, { payload }) => {
        state.isGettingAnnouncementData = false;
      })
      .addCase(updateAnnouncement.pending, (state, { payload }) => {
        state.isUpdatingAnnouncement = true;
      })
      .addCase(updateAnnouncement.fulfilled, (state, { payload }) => {
        state.isUpdatingAnnouncement = false;
      })
      .addCase(updateAnnouncement.rejected, (state, { payload }) => {
        state.isUpdatingAnnouncement = false;
      })
      .addCase(updateAnnouncementStatus.pending, (state, { payload }) => {
        state.isAnnouncementStatusUpdating = true;
      })
      .addCase(updateAnnouncementStatus.fulfilled, (state, { payload }) => {
        state.isAnnouncementStatusUpdating = false;
        state.announcement.status = payload?.data?.data?.status;
      })
      .addCase(updateAnnouncementStatus.rejected, (state, { payload }) => {
        state.isAnnouncementStatusUpdating = false;
      })
  },
});

export const {
  saveAnnouncementValue,
  clearAnnouncementState,
} = announcementSlice.actions;

export const announcementSelector = (state) => state.announcement;
